import React from 'react'
import {Modal} from 'react-bootstrap'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import axios from 'axios'

function PromosItem(props) {
  console.log(props.promo.idElement)

  const url = 'https://puntosurgdl.com/backend/'

  const uploadFile = () => {
    const data = new FormData()

    if (document.getElementById(`file-${props.promo.idElement}`).files.length !== 0) {
      for (
        let i = 0;
        i < document.getElementById(`file-${props.promo.idElement}`).files.length;
        i++
      ) {
        data.append('file[]', document.getElementById(`file-${props.promo.idElement}`).files[i])
      }

      data.append('name', props.promo.idElement)

      axios
        .post(url + 'uploadNewPromo.php', data, {
          // receive two parameter endpoint url ,form data
        })
        .then(
          (res) => {
            // then print response status
            console.log(res.data)
            props.setPromos(res.data.data)
          },
          (error) => {
            alert(error)
          }
        )
    } else {
      console.log('vacío')
    }
  }

  return (
    <div className='col-lg-4'>
      <div className='card card-custom overlay overflow-hidden card-promo'>
        <div className='card-body p-0'>
          <div className='overlay-wrapper'>
            <img
              src={props.promo.url}
              alt=''
              className='w-100 rounded home-promociones-1 img-promociones'
            />
          </div>
          <div className='overlay-layer bg-dark bg-opacity-10'>
            <div className='d-flex flex-grow-1 flex-center py-5'>
              <input
                type='file'
                id={`file-${props.promo.idElement}`}
                name={`file-${props.promo.idElement}`}
                className='input-image'
                onChange={() => uploadFile()}
                accept='image/*'
              />
              <input
                id='button'
                type='button'
                value='Cambiar...'
                className='btn btn-light-primary mr-2 btn-change'
                onClick={() => document.getElementById(`file-${props.promo.idElement}`).click()}
              />
              <input
                id='button'
                type='button'
                value='Eliminar'
                className='btn btn-danger'
                onClick={() => props.deletePromo(props.promo.idElement)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {PromosItem}
